/* GENERATED from extensions/hyde-tier-discount/src/tier_logic.js. DO NOT HAND EDIT. */
(function (root) {
"use strict";
/**
 * Hyde tier pricing contract and pure product-discount logic.
 *
 * A PRESENT invalid variant/product/shop metafield is authoritative failure:
 * it never falls through to a lower-precedence schedule. Only an absent
 * metafield falls through. The production extension is product-only.
 */

const SCHEDULE_NAMESPACE = "hyde";
const SCHEDULE_KEY = "tiers";
const CHECKOUT_SCHEDULE_NAMESPACE = "$app:hyde-tiers";
const CHECKOUT_SCHEDULE_KEY = "schedule";
const SCHEDULE_SCHEMA_VERSION = "hyde.tiers.v1";
const CONFIG_SCHEMA_VERSION = "hyde.discount-config.v1";
const LEGACY_PARITY_HARD_STOP = "2026-09-01";
const MAX_PERCENT_DISCOUNT_PCT_HARD = 50;
const MAX_EXACT_PRICE_DISCOUNT_PCT_HARD = 80;

const TOP_LEVEL_KEYS = new Set([
  "schema_version", "schedule_id", "schedule_version", "integrity_sha256",
  "currency", "status", "approval", "effective_window", "tiers", "safety",
  "allow_equivalent_dual_encoding",
]);
const TIER_KEYS = new Set(["min", "discount_pct", "price_cents", "label"]);
const SAFETY_KEYS = new Set(["min_unit_price_cents", "max_discount_pct", "reference_price_cents"]);
const APPROVAL_KEYS = new Set(["status", "approved_at_utc", "approval_ref"]);
const WINDOW_KEYS = new Set(["start_date", "end_date"]);
const CONFIG_KEYS = new Set([
  "config_schema_version", "quantity_scope", "default_schedule",
  "excluded_product_ids", "excluded_variant_ids", "product_discount_message",
  "legacy_parity_mode",
]);
const LEGACY_MODE_KEYS = new Set(["enabled", "expires_on", "migration_id"]);

function stableStringify(value) {
  if (value === null || typeof value !== "object") return JSON.stringify(value);
  if (Array.isArray(value)) return `[${value.map(stableStringify).join(",")}]`;
  return `{${Object.keys(value).sort().map((key) => `${JSON.stringify(key)}:${stableStringify(value[key])}`).join(",")}}`;
}

/** Pure SHA-256 for the Shopify Function runtime (no network, no Node crypto). */
function sha256Hex(message) {
  const bytes = utf8Bytes(message);
  const bitLength = bytes.length * 8;
  const padded = bytes.slice();
  padded.push(0x80);
  while (padded.length % 64 !== 56) padded.push(0);
  const high = Math.floor(bitLength / 0x100000000);
  const low = bitLength >>> 0;
  for (let shift = 24; shift >= 0; shift -= 8) padded.push((high >>> shift) & 0xff);
  for (let shift = 24; shift >= 0; shift -= 8) padded.push((low >>> shift) & 0xff);

  const k = [
    0x428a2f98,0x71374491,0xb5c0fbcf,0xe9b5dba5,0x3956c25b,0x59f111f1,0x923f82a4,0xab1c5ed5,
    0xd807aa98,0x12835b01,0x243185be,0x550c7dc3,0x72be5d74,0x80deb1fe,0x9bdc06a7,0xc19bf174,
    0xe49b69c1,0xefbe4786,0x0fc19dc6,0x240ca1cc,0x2de92c6f,0x4a7484aa,0x5cb0a9dc,0x76f988da,
    0x983e5152,0xa831c66d,0xb00327c8,0xbf597fc7,0xc6e00bf3,0xd5a79147,0x06ca6351,0x14292967,
    0x27b70a85,0x2e1b2138,0x4d2c6dfc,0x53380d13,0x650a7354,0x766a0abb,0x81c2c92e,0x92722c85,
    0xa2bfe8a1,0xa81a664b,0xc24b8b70,0xc76c51a3,0xd192e819,0xd6990624,0xf40e3585,0x106aa070,
    0x19a4c116,0x1e376c08,0x2748774c,0x34b0bcb5,0x391c0cb3,0x4ed8aa4a,0x5b9cca4f,0x682e6ff3,
    0x748f82ee,0x78a5636f,0x84c87814,0x8cc70208,0x90befffa,0xa4506ceb,0xbef9a3f7,0xc67178f2,
  ];
  let h = [0x6a09e667,0xbb67ae85,0x3c6ef372,0xa54ff53a,0x510e527f,0x9b05688c,0x1f83d9ab,0x5be0cd19];
  const w = new Array(64);
  for (let offset = 0; offset < padded.length; offset += 64) {
    for (let i = 0; i < 16; i += 1) {
      const j = offset + i * 4;
      w[i] = ((padded[j] << 24) | (padded[j + 1] << 16) | (padded[j + 2] << 8) | padded[j + 3]) >>> 0;
    }
    for (let i = 16; i < 64; i += 1) {
      const s0 = (rotr(w[i - 15], 7) ^ rotr(w[i - 15], 18) ^ (w[i - 15] >>> 3)) >>> 0;
      const s1 = (rotr(w[i - 2], 17) ^ rotr(w[i - 2], 19) ^ (w[i - 2] >>> 10)) >>> 0;
      w[i] = (w[i - 16] + s0 + w[i - 7] + s1) >>> 0;
    }
    let [a,b,c,d,e,f,g,hh] = h;
    for (let i = 0; i < 64; i += 1) {
      const s1 = (rotr(e, 6) ^ rotr(e, 11) ^ rotr(e, 25)) >>> 0;
      const ch = ((e & f) ^ (~e & g)) >>> 0;
      const t1 = (hh + s1 + ch + k[i] + w[i]) >>> 0;
      const s0 = (rotr(a, 2) ^ rotr(a, 13) ^ rotr(a, 22)) >>> 0;
      const maj = ((a & b) ^ (a & c) ^ (b & c)) >>> 0;
      const t2 = (s0 + maj) >>> 0;
      hh = g; g = f; f = e; e = (d + t1) >>> 0; d = c; c = b; b = a; a = (t1 + t2) >>> 0;
    }
    h = [
      (h[0] + a) >>> 0,(h[1] + b) >>> 0,(h[2] + c) >>> 0,(h[3] + d) >>> 0,
      (h[4] + e) >>> 0,(h[5] + f) >>> 0,(h[6] + g) >>> 0,(h[7] + hh) >>> 0,
    ];
  }
  return h.map((n) => n.toString(16).padStart(8, "0")).join("");
}

function rotr(value, bits) { return (value >>> bits) | (value << (32 - bits)); }
function utf8Bytes(value) {
  const encoded = unescape(encodeURIComponent(value));
  const out = [];
  for (let i = 0; i < encoded.length; i += 1) out.push(encoded.charCodeAt(i));
  return out;
}

function scheduleIntegrityPayload(envelope) {
  if (!envelope || typeof envelope !== "object" || Array.isArray(envelope)) return null;
  const copy = {};
  for (const key of Object.keys(envelope)) if (key !== "integrity_sha256") copy[key] = envelope[key];
  return copy;
}

function computeScheduleIntegrity(envelope) {
  const payload = scheduleIntegrityPayload(envelope);
  return payload ? sha256Hex(stableStringify(payload)) : null;
}

function validateScheduleEnvelope(raw, context = {}) {
  const parsed = parseJsonValue(raw);
  if (!parsed.ok) return invalid("SCHEDULE_JSON_INVALID");
  const data = parsed.value;
  if (Array.isArray(data)) return validateLegacyParity(data, context);
  if (!isPlainObject(data)) return invalid("SCHEDULE_ENVELOPE_REQUIRED");
  if (!onlyKeys(data, TOP_LEVEL_KEYS)) return invalid("SCHEDULE_UNKNOWN_FIELD");
  if (data.schema_version !== SCHEDULE_SCHEMA_VERSION) return invalid("SCHEDULE_SCHEMA_VERSION_INVALID");
  if (!isCanonicalId(data.schedule_id)) return invalid("SCHEDULE_ID_INVALID");
  if (!Number.isSafeInteger(data.schedule_version) || data.schedule_version < 1) return invalid("SCHEDULE_VERSION_INVALID");
  if (data.currency !== "USD") return invalid("SCHEDULE_CURRENCY_INVALID");
  if (data.status !== "ACTIVE") return invalid("SCHEDULE_STATUS_NOT_ACTIVE");
  if (!validateApproval(data.approval)) return invalid("SCHEDULE_APPROVAL_INVALID");
  if (!validateWindow(data.effective_window, context.currentDate)) return invalid("SCHEDULE_EFFECTIVE_WINDOW_INVALID");
  if (!/^[a-f0-9]{64}$/.test(data.integrity_sha256 || "")) return invalid("SCHEDULE_HASH_FORMAT_INVALID");
  // Shopify caps discount Functions at 11M instructions. Checkout reads only
  // app-owned schedules; their canonical hash is CAS-validated before write.
  // Browser/public validation still recomputes the hash. The Function retains
  // full schema, approval, window, safety, currency and monotonicity checks.
  if (context.trustedAppOwned !== true && computeScheduleIntegrity(data) !== data.integrity_sha256) return invalid("SCHEDULE_HASH_MISMATCH");
  if (!Array.isArray(data.tiers) || data.tiers.length === 0 || data.tiers.length > 32) return invalid("SCHEDULE_TIERS_INVALID");
  const safety = validateSafety(data.safety);
  if (!safety.valid) return safety;
  if (data.allow_equivalent_dual_encoding != null && data.allow_equivalent_dual_encoding !== true) {
    return invalid("SCHEDULE_DUAL_ENCODING_FLAG_INVALID");
  }
  const tiers = [];
  const seen = new Set();
  let priorMin = 0;
  for (const tier of data.tiers) {
    const checked = validateTier(tier, data, safety.value);
    if (!checked.valid) return checked;
    if (seen.has(checked.value.min)) return invalid("SCHEDULE_DUPLICATE_THRESHOLD");
    if (checked.value.min <= priorMin) return invalid("SCHEDULE_THRESHOLDS_NOT_STRICTLY_ASCENDING");
    seen.add(checked.value.min);
    priorMin = checked.value.min;
    tiers.push(checked.value);
  }
  const schedule = {
    schemaVersion: data.schema_version,
    scheduleId: data.schedule_id,
    scheduleVersion: data.schedule_version,
    hash: data.integrity_sha256,
    currency: data.currency,
    status: data.status,
    approval: data.approval,
    effectiveWindow: data.effective_window,
    tiers,
    safety: safety.value,
    allowEquivalentDualEncoding: data.allow_equivalent_dual_encoding === true,
    legacy: false,
  };
  if (context.baseCents != null) {
    const runtime = validateScheduleForBase(schedule, context.baseCents, context.currency || "USD");
    if (!runtime.valid) return runtime;
  }
  return { valid: true, schedule, reason: null };
}

function validateScheduleForBase(schedule, baseCents, lineCurrency = "USD") {
  if (!Number.isSafeInteger(baseCents) || baseCents <= 0) return invalid("BASE_PRICE_INVALID");
  let priorEffective = baseCents;
  for (const tier of schedule.tiers) {
    if (tier.priceCents != null && lineCurrency !== schedule.currency) return invalid("EXACT_CENTS_CURRENCY_MISMATCH");
    if (tier.priceCents != null && tier.discountPct != null && schedule.safety?.reference_price_cents !== baseCents) {
      return invalid("DUAL_ENCODING_REFERENCE_PRICE_MISMATCH");
    }
    const effective = effectiveUnitPriceCents(tier, baseCents);
    if (!Number.isSafeInteger(effective) || effective <= 0) return invalid("SCHEDULE_FREE_OR_UNSAFE_PRICE");
    if (effective > priorEffective) return invalid("SCHEDULE_EFFECTIVE_PRICE_NOT_MONOTONE");
    if (schedule.safety?.min_unit_price_cents != null && effective < schedule.safety.min_unit_price_cents) {
      return invalid("SCHEDULE_MIN_UNIT_PRICE_BREACH");
    }
    const effectiveDiscountPct = ((baseCents - effective) * 100) / baseCents;
    if (schedule.safety?.max_discount_pct != null && effectiveDiscountPct > schedule.safety.max_discount_pct + 1e-9) {
      return invalid("SCHEDULE_MAX_DISCOUNT_BREACH");
    }
    priorEffective = effective;
  }
  return { valid: true, schedule, reason: null };
}

function validateTier(tier, envelope, safety) {
  if (!isPlainObject(tier) || !onlyKeys(tier, TIER_KEYS)) return invalid("SCHEDULE_TIER_MEMBER_INVALID");
  if (!Number.isSafeInteger(tier.min) || tier.min < 1) return invalid("SCHEDULE_TIER_MIN_INVALID");
  const hasPct = Object.prototype.hasOwnProperty.call(tier, "discount_pct");
  const hasPrice = Object.prototype.hasOwnProperty.call(tier, "price_cents");
  if (hasPct === hasPrice && !(hasPct && envelope.allow_equivalent_dual_encoding === true)) {
    return invalid(hasPct ? "SCHEDULE_TIER_CONTRADICTORY_PRICE" : "SCHEDULE_TIER_PRICE_MISSING");
  }
  let pct = null;
  if (hasPct) {
    pct = tier.discount_pct;
    if (typeof pct !== "number" || !Number.isFinite(pct) || pct < 0 || pct > MAX_PERCENT_DISCOUNT_PCT_HARD || decimalPlaces(pct) > 4) {
      return invalid("SCHEDULE_TIER_PERCENT_INVALID");
    }
    if (pct === 100) return invalid("SCHEDULE_FREE_OR_UNSAFE_PRICE");
  }
  let priceCents = null;
  if (hasPrice) {
    priceCents = tier.price_cents;
    if (!Number.isSafeInteger(priceCents) || priceCents <= 0) return invalid("SCHEDULE_TIER_PRICE_CENTS_INVALID");
  }
  if (hasPct && hasPrice) {
    const reference = safety?.reference_price_cents;
    if (!Number.isSafeInteger(reference) || reference <= 0) return invalid("SCHEDULE_DUAL_ENCODING_REFERENCE_REQUIRED");
    if (priceCents !== percentUnitPriceCents(reference, pct)) return invalid("SCHEDULE_DUAL_ENCODING_NOT_EQUIVALENT");
  }
  if (tier.label != null && (!isSafeLabel(tier.label))) return invalid("SCHEDULE_TIER_LABEL_INVALID");
  return { valid: true, value: { min: tier.min, discountPct: pct, priceCents, label: tier.label || "" } };
}

function validateSafety(safety) {
  if (!isPlainObject(safety) || !onlyKeys(safety, SAFETY_KEYS)) return invalid("SCHEDULE_SAFETY_INVALID");
  if (!Object.prototype.hasOwnProperty.call(safety, "min_unit_price_cents")
    || !Object.prototype.hasOwnProperty.call(safety, "max_discount_pct")) {
    return invalid("SCHEDULE_SAFETY_REQUIRED");
  }
  const out = {};
  for (const key of ["min_unit_price_cents", "reference_price_cents"]) {
    if (safety[key] != null && (!Number.isSafeInteger(safety[key]) || safety[key] <= 0)) return invalid("SCHEDULE_SAFETY_CENTS_INVALID");
    if (safety[key] != null) out[key] = safety[key];
  }
  if (safety.max_discount_pct != null) {
    if (typeof safety.max_discount_pct !== "number" || !Number.isFinite(safety.max_discount_pct)
      || safety.max_discount_pct < 0 || safety.max_discount_pct > MAX_EXACT_PRICE_DISCOUNT_PCT_HARD) return invalid("SCHEDULE_SAFETY_PERCENT_INVALID");
    out.max_discount_pct = safety.max_discount_pct;
  }
  return { valid: true, value: out };
}

function validateApproval(value) {
  return isPlainObject(value) && onlyKeys(value, APPROVAL_KEYS)
    && value.status === "APPROVED"
    && isIsoUtc(value.approved_at_utc)
    && isCanonicalId(value.approval_ref);
}

function validateWindow(value, currentDate) {
  if (!isPlainObject(value) || !onlyKeys(value, WINDOW_KEYS) || !isDate(value.start_date)) return false;
  if (value.end_date != null && (!isDate(value.end_date) || value.end_date < value.start_date)) return false;
  if (currentDate != null) {
    if (!isDate(currentDate) || currentDate < value.start_date) return false;
    if (value.end_date != null && currentDate > value.end_date) return false;
  }
  return true;
}

function validateLegacyParity(data, context) {
  const legacy = context.legacyParityMode;
  if (!legacy?.enabled || !isDate(legacy.expires_on) || !isCanonicalId(legacy.migration_id)) return invalid("LEGACY_PARITY_NOT_ENABLED");
  if (legacy.expires_on > LEGACY_PARITY_HARD_STOP) return invalid("LEGACY_PARITY_EXPIRY_UNBOUNDED");
  if (!isDate(context.currentDate) || context.currentDate > legacy.expires_on) return invalid("LEGACY_PARITY_EXPIRED");
  const expected = [[1,0],[2,15],[12,20],[24,25]];
  if (data.length !== expected.length) return invalid("LEGACY_PARITY_SHAPE_INVALID");
  const tiers = [];
  for (let i = 0; i < expected.length; i += 1) {
    const tier = data[i];
    if (!isPlainObject(tier) || !onlyKeys(tier, new Set(["min","discount_pct","label"]))) return invalid("LEGACY_PARITY_SHAPE_INVALID");
    if (tier.min !== expected[i][0] || tier.discount_pct !== expected[i][1]) return invalid("LEGACY_PARITY_VALUE_INVALID");
    if (tier.label != null && !isSafeLabel(tier.label)) return invalid("LEGACY_PARITY_LABEL_INVALID");
    tiers.push({ min: tier.min, discountPct: tier.discount_pct, priceCents: null, label: tier.label || "" });
  }
  return { valid: true, reason: null, schedule: {
    schemaVersion: "hyde.tiers.legacy-parity", scheduleId: legacy.migration_id,
    scheduleVersion: 0, hash: `legacy:${sha256Hex(stableStringify(data))}`, currency: "USD",
    status: "ACTIVE", approval: null, effectiveWindow: { start_date: currentDateFloor(context.currentDate), end_date: legacy.expires_on },
    tiers, safety: null, allowEquivalentDualEncoding: false, legacy: true,
  } };
}

function normalizeConfig(raw, currentDate, options = {}) {
  const parsed = parseJsonValue(raw);
  if (!parsed.ok || !isPlainObject(parsed.value) || !onlyKeys(parsed.value, CONFIG_KEYS)) return { valid: false, reason: "CONFIG_INVALID" };
  const data = parsed.value;
  if (data.config_schema_version !== CONFIG_SCHEMA_VERSION) return { valid: false, reason: "CONFIG_SCHEMA_VERSION_INVALID" };
  if (data.quantity_scope !== "line") return { valid: false, reason: "CONFIG_QUANTITY_SCOPE_INVALID" };
  if (!isStringArray(data.excluded_product_ids) || !isStringArray(data.excluded_variant_ids)) return { valid: false, reason: "CONFIG_EXCLUSIONS_INVALID" };
  if (typeof data.product_discount_message !== "string" || !data.product_discount_message.trim() || data.product_discount_message.length > 80) {
    return { valid: false, reason: "CONFIG_MESSAGE_INVALID" };
  }
  const legacy = data.legacy_parity_mode || { enabled: false };
  if (!isPlainObject(legacy) || !onlyKeys(legacy, LEGACY_MODE_KEYS) || typeof legacy.enabled !== "boolean") return { valid: false, reason: "CONFIG_LEGACY_MODE_INVALID" };
  const legacyShapeValid = legacy.enabled
    ? Object.keys(legacy).length === 3 && isDate(legacy.expires_on) && legacy.expires_on <= LEGACY_PARITY_HARD_STOP && isCanonicalId(legacy.migration_id)
    : Object.keys(legacy).length === 1;
  if (!legacyShapeValid) {
    return { valid: false, reason: "CONFIG_LEGACY_MODE_INVALID" };
  }
  let defaultSchedule = null;
  if (data.default_schedule != null) {
    const checked = validateScheduleEnvelope(data.default_schedule, {
      currentDate, legacyParityMode: legacy, trustedAppOwned: options.trustedAppOwned === true,
    });
    if (!checked.valid) return { valid: false, reason: `CONFIG_DEFAULT_${checked.reason}` };
    defaultSchedule = checked.schedule;
  }
  return {
    valid: true,
    reason: null,
    quantityScope: data.quantity_scope,
    defaultSchedule,
    excludedProductIds: new Set(data.excluded_product_ids),
    excludedVariantIds: new Set(data.excluded_variant_ids),
    productMessage: data.product_discount_message.trim(),
    legacyParityMode: legacy,
    trustedAppOwned: options.trustedAppOwned === true,
    currentDate,
  };
}

/**
 * Resolve present sources in strict precedence. Invalid-present is a block;
 * absence alone falls through.
 */
function resolveLineSchedule(merchandise, shopMetafield, config, baseCents, currency) {
  const sources = [
    ["VARIANT", merchandise?.variantSchedule],
    ["PRODUCT", merchandise?.product?.productSchedule],
    ["SHOP", shopMetafield],
  ];
  for (const [source, metafield] of sources) {
    if (metafield == null) continue;
    const raw = Object.prototype.hasOwnProperty.call(metafield, "value") ? metafield.value : metafield;
    const checked = validateScheduleEnvelope(raw, {
      currentDate: config.currentDate, legacyParityMode: config.legacyParityMode,
      baseCents, currency, trustedAppOwned: config.trustedAppOwned === true,
    });
    if (!checked.valid) return { valid: false, reason: `${source}_${checked.reason}`, source };
    return { valid: true, schedule: checked.schedule, source };
  }
  if (config.defaultSchedule) {
    const runtime = validateScheduleForBase(config.defaultSchedule, baseCents, currency);
    return runtime.valid
      ? { valid: true, schedule: config.defaultSchedule, source: "CONFIG_DEFAULT" }
      : { valid: false, reason: `CONFIG_DEFAULT_${runtime.reason}`, source: "CONFIG_DEFAULT" };
  }
  return { valid: false, reason: "SCHEDULE_ABSENT", source: null };
}

function buildEligibleLines(cartLines, config, shopMetafield) {
  if (!config?.valid) return [];
  const lines = [];
  for (const line of cartLines || []) {
    const merch = line?.merchandise;
    if (!merch || merch.__typename !== "ProductVariant") continue;
    if (config.excludedVariantIds.has(merch.id)) continue;
    if (merch.product && config.excludedProductIds.has(merch.product.id)) continue;
    const qty = strictPositiveInteger(line.quantity);
    const baseCents = amountToCents(line?.cost?.amountPerQuantity?.amount);
    const currency = line?.cost?.amountPerQuantity?.currencyCode;
    if (qty == null || baseCents == null || typeof currency !== "string") continue;
    const resolved = resolveLineSchedule(merch, shopMetafield, config, baseCents, currency);
    if (!resolved.valid) continue;
    lines.push({ id: line.id, qty, baseCents, currency, productId: merch.product?.id ?? merch.id, schedule: resolved.schedule, scheduleSource: resolved.source });
  }
  return lines;
}

function resolveTier(schedule, qty) {
  const tiers = schedule?.tiers;
  if (!Array.isArray(tiers) || !Number.isSafeInteger(qty) || qty < 1) return null;
  let active = null;
  for (const tier of tiers) {
    if (tier.min <= qty) active = tier;
    else break;
  }
  return active;
}

function effectiveUnitPriceCents(tier, baseCents) {
  if (!tier) return baseCents;
  if (tier.priceCents != null) return tier.priceCents;
  return percentUnitPriceCents(baseCents, tier.discountPct);
}

function percentUnitPriceCents(baseCents, pct) {
  const scaledPct = Math.round(pct * 10000);
  const discount = Math.floor((baseCents * scaledPct) / 1000000);
  return baseCents - discount;
}

function perUnitDiscountCents(tier, baseCents) {
  return Math.max(0, baseCents - effectiveUnitPriceCents(tier, baseCents));
}

function tierDiscounts(tier, baseCents) { return !!tier && effectiveUnitPriceCents(tier, baseCents) < baseCents; }

function effectiveQuantities(lines, scope) {
  if (scope !== "line") return new Map();
  return new Map(lines.map((line) => [line.id, line.qty]));
}

function decideLineDiscounts(lines, config) {
  const quantities = effectiveQuantities(lines, config.quantityScope);
  const decisions = [];
  for (const line of lines) {
    const tier = resolveTier(line.schedule, quantities.get(line.id));
    if (!tierDiscounts(tier, line.baseCents)) continue;
    if (tier.priceCents != null) {
      const perUnit = perUnitDiscountCents(tier, line.baseCents);
      decisions.push({
        lineId: line.id, kind: "fixed", lineAmountCents: perUnit * line.qty, tier,
        scheduleId: line.schedule.scheduleId, scheduleVersion: line.schedule.scheduleVersion,
        scheduleHash: line.schedule.hash,
      });
    } else {
      decisions.push({
        lineId: line.id, kind: "percentage", percentage: tier.discountPct, tier,
        scheduleId: line.schedule.scheduleId, scheduleVersion: line.schedule.scheduleVersion,
        scheduleHash: line.schedule.hash,
      });
    }
  }
  return decisions;
}

function centsToAmount(cents) {
  if (!Number.isSafeInteger(cents) || cents < 0) return null;
  return `${Math.floor(cents / 100)}.${String(cents % 100).padStart(2, "0")}`;
}

function amountToCents(amount) {
  if (typeof amount === "number") {
    if (!Number.isFinite(amount) || amount < 0 || Math.round(amount * 100) !== amount * 100) return null;
    return Math.round(amount * 100);
  }
  if (typeof amount !== "string" || !/^\d+(?:\.\d{1,2})?$/.test(amount)) return null;
  const [whole, decimal = ""] = amount.split(".");
  const cents = Number(whole) * 100 + Number(decimal.padEnd(2, "0"));
  return Number.isSafeInteger(cents) ? cents : null;
}

function parseJsonValue(raw) {
  if (typeof raw !== "string") return { ok: true, value: raw };
  try { return { ok: true, value: JSON.parse(raw) }; } catch { return { ok: false, value: null }; }
}
function invalid(reason) { return { valid: false, schedule: null, reason }; }
function isPlainObject(value) { return !!value && typeof value === "object" && !Array.isArray(value); }
function onlyKeys(value, allowed) { return Object.keys(value).every((key) => allowed.has(key)); }
function isCanonicalId(value) { return typeof value === "string" && /^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/.test(value); }
function isSafeLabel(value) { return typeof value === "string" && value.length <= 80 && !/[<>]/.test(value); }
function isIsoUtc(value) {
  if (typeof value !== "string") return false;
  const match = /^(\d{4}-\d{2}-\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d{3}))?Z$/.exec(value);
  if (!match || !isDate(match[1])) return false;
  return Number(match[2]) <= 23 && Number(match[3]) <= 59 && Number(match[4]) <= 59;
}
function isDate(value) {
  if (typeof value !== "string") return false;
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return false;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  if (year < 1 || month < 1 || month > 12 || day < 1) return false;
  const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  const days = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  return day <= days[month - 1];
}
function currentDateFloor(value) { return isDate(value) ? value : null; }
function strictPositiveInteger(value) { return Number.isSafeInteger(value) && value > 0 ? value : null; }
function decimalPlaces(value) { const text = String(value); return text.includes(".") ? text.split(".")[1].length : 0; }
function isStringArray(value) { return Array.isArray(value) && value.every((item) => typeof item === "string" && item.length > 0) && new Set(value).size === value.length; }


function removeStamp(form, name) {
  const input = form.querySelector('input[name="properties[' + name + ']"]');
  if (input) input.remove();
}

function addStamp(form, name, value) {
  const input = document.createElement("input");
  input.type = "hidden";
  input.name = "properties[" + name + "]";
  input.value = value;
  input.setAttribute("data-hyde-tier-stamp", "true");
  form.appendChild(input);
}

function variantEntryFromMap(raw, variantId) {
  if (typeof raw !== "string" || variantId == null) return null;
  let map;
  try { map = JSON.parse(raw); } catch { return null; }
  const entry = map && typeof map === "object" ? map[String(variantId)] : null;
  if (!entry || typeof entry !== "object" || !Number.isInteger(entry.baseCents)
    || entry.baseCents <= 0 || typeof entry.currency !== "string"
    || typeof entry.currentDate !== "string") return null;
  return entry;
}

function syncEnvelopeForSelectedVariant(form) {
  const mapElement = form.querySelector("[data-hyde-tier-variant-map]");
  if (!mapElement) return { present: false, mapped: false };
  const variantInput = form.querySelector('input[name="id"]');
  const entry = variantEntryFromMap(mapElement.textContent, variantInput && variantInput.value);
  let envelope = form.querySelector("[data-hyde-tier-envelope]");
  if (!entry || entry.record == null) {
    if (envelope) envelope.remove();
    return { present: false, mapped: true };
  }
  if (!envelope) {
    envelope = document.createElement("script");
    envelope.type = "application/json";
    envelope.setAttribute("data-hyde-tier-envelope", "true");
    form.appendChild(envelope);
  }
  envelope.textContent = JSON.stringify(entry.record);
  envelope.dataset.baseCents = String(entry.baseCents);
  envelope.dataset.currency = entry.currency;
  envelope.dataset.currentDate = entry.currentDate;
  return { present: true, mapped: true };
}

function prepareForm(form) {
  if (!form) return { valid: false, reason: "FORM_ABSENT" };
  removeStamp(form, "_hyde_tier_v");
  removeStamp(form, "_hyde_tier_hash");
  syncEnvelopeForSelectedVariant(form);
  const element = form.querySelector("[data-hyde-tier-envelope]");
  if (!element) return { valid: false, reason: "SCHEDULE_ABSENT" };
  const baseCents = Number(element.dataset.baseCents);
  const currency = element.dataset.currency;
  const currentDate = element.dataset.currentDate;
  const result = validateScheduleEnvelope(element.textContent, { baseCents, currency, currentDate });
  if (!result.valid) return result;
  addStamp(form, "_hyde_tier_v", result.schedule.scheduleId + "@" + result.schedule.scheduleVersion);
  addStamp(form, "_hyde_tier_hash", result.schedule.hash);
  return result;
}

function priceSpecifications(schedule, baseCents, currency) {
  const specs = [];
  for (let i = 0; i < schedule.tiers.length; i += 1) {
    const tier = schedule.tiers[i];
    const next = schedule.tiers[i + 1];
    const quantity = { "@type": "QuantitativeValue", minValue: tier.min };
    if (next) quantity.maxValue = next.min - 1;
    specs.push({
      "@type": "UnitPriceSpecification",
      price: (effectiveUnitPriceCents(tier, baseCents) / 100).toFixed(2),
      priceCurrency: currency,
      eligibleQuantity: quantity,
    });
  }
  return specs;
}

function applyStructuredData(envelopeElement, jsonLdElement) {
  if (!envelopeElement || !jsonLdElement) return { valid: false, reason: "STRUCTURED_DATA_INPUT_ABSENT" };
  let graph;
  try { graph = JSON.parse(jsonLdElement.textContent); } catch { return { valid: false, reason: "STRUCTURED_DATA_JSON_INVALID" }; }
  const baseCents = Number(envelopeElement.dataset.baseCents);
  const currency = envelopeElement.dataset.currency;
  const result = validateScheduleEnvelope(envelopeElement.textContent, {
    baseCents, currency, currentDate: envelopeElement.dataset.currentDate,
  });
  if (!graph.offers || typeof graph.offers !== "object") return { valid: false, reason: "STRUCTURED_DATA_OFFER_ABSENT" };
  delete graph.offers.priceSpecification;
  if (typeof graph.offers.description === "string" && graph.offers.description.includes("Volume discount")) delete graph.offers.description;
  if (result.valid) {
    graph.offers.priceSpecification = priceSpecifications(result.schedule, baseCents, currency);
    graph.offers.description = "Approved volume pricing applies automatically at checkout at the quantities in priceSpecification.";
  }
  jsonLdElement.textContent = JSON.stringify(graph);
  return result;
}

function initialize(scope) {
  const rootNode = scope || document;
  rootNode.querySelectorAll("form").forEach(function (form) {
    if (form.querySelector("[data-hyde-tier-envelope]")) prepareForm(form);
  });
  rootNode.querySelectorAll("[data-hyde-structured-envelope]").forEach(function (element) {
    const target = document.getElementById(element.dataset.jsonldTarget);
    if (target) applyStructuredData(element, target);
  });
}

root.HydeTierContract = Object.freeze({
  computeScheduleIntegrity,
  effectiveUnitPriceCents,
  priceSpecifications,
  prepareForm,
  resolveTier,
  sha256Hex,
  stableStringify,
  validateScheduleEnvelope,
  validateScheduleForBase,
  applyStructuredData,
  initialize,
  syncEnvelopeForSelectedVariant,
  variantEntryFromMap,
});
if (typeof document !== "undefined") {
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { initialize(document); });
  else initialize(document);
}
})(typeof window !== "undefined" ? window : globalThis);
